import { Component, OnInit, ViewChild } from '@angular/core';
import { OrderService } from '../../../core/services/order.service';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, DataBindingDirective } from '@progress/kendo-angular-grid';
import { IGetOrdersInquiryBody, IGetInvoiceBody, IInvoiceInquiryLbl, IGetInvoicePdfBody } from '../../../core/models';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { sampleProducts } from '../sampleData';
import { formatDate } from '@angular/common';
import { CommonService } from '../../../core/services/common.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';
import { GridSettings } from '../../../core/common';
import { StatePersistingService } from '../../../core/services/state-persisting.service';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as _ from "lodash";
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { PaymentService } from '../../../core/services/payment.service';
import { NavigationEnd, Router } from '@angular/router';
import { NotifyType } from '../../../core/enums/NotifyType';
import { AppNotifyService } from '../../../core/services/app-notify.service';
import { UserService } from '../../../core/services/user.service';
import { filter } from 'rxjs/operators';

declare const gtag: Function;

@Component({
  selector: 'app-invoice-inquiry',
  templateUrl: './invoice-inquiry.component.html',
  styleUrls: ['./invoice-inquiry.component.scss']
})
export class InvoiceInquiryComponent implements OnInit {
  invoiceInquiryGridData: GridDataResult;
  invoiceGridData: any[] = [];
  invoiceLoading: boolean;
  loadingPDF: boolean;
  loadingExcel: boolean;
  searchText: string = '';
  @ViewChild(DataBindingDirective, { static: false }) dataBinding: DataBindingDirective;
  constructor(private orderService: OrderService,
    private commonService: CommonService,
    private persistingService: StatePersistingService,
    private languageTranslationService: LanguageTranslationService,
    private paymentService: PaymentService,
    private router: Router,
    private userService: UserService,
    private appNotifyService: AppNotifyService,) {

    const invoiceGridSettings: GridSettings = null;//this.persistingService.get(this.orderService.readUserObject.userName + 'invoiceInquiryGridSetting');

    if (invoiceGridSettings) {
      this.invoiceGridSettings = this.mapGridSettings(invoiceGridSettings);
    } else {
      // you can reset 
    }

    this.previousUrl = '';
    if (this.router.getCurrentNavigation().previousNavigation) {
      this.previousUrl = this.router.getCurrentNavigation().previousNavigation.finalUrl.toString();
      console.log('prev2:' + this.previousUrl);
    }
  }

  ngOnInit() {
    this.loadLanguageTranslationData();
    this.loadInvoiceInquiryGrid(this.fromDate, this.toDate);
  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "invoiceInquiryLbl" },
      { controlName: "invoiceNumberLbl" },
      { controlName: "invoiceDatelblLbl" },
      { controlName: "invoiceTypeLbl" },
      { controlName: "poLbl" },
      { controlName: "jobNameLbl" },
      { controlName: "originalAmountLbl" },
      { controlName: "amountDueLbl" },
      { controlName: "marketSegmentLbl" },
      { controlName: "invoiceStatusLbl" },
      { controlName: "exportToExcelLbl" },
      { controlName: "exportToPDFLbl" },
      { controlName: "downloadInvoiceLbl" },
    ];
    const componentName = "invoiceInquiry";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.invlblText = response[response.length - 1];
      this.initializeGridHeader();
    }
  }
  //#endregion
  //#region label declaration  
  protected invoiceInquiry = {
    invoiceInquiryLbl: 'Invoice Inquiry',
    invoiceNumberLbl: 'Invoice#',
    invoiceDateLbl: 'Invoice Date', //need to give proper name in DB language code table
    invoiceTypeLbl: 'Type',
    poLbl: 'PO#',
    jobNameLbl: 'Job Name',
    originalAmountLbl: 'Original Amount',
    amountDueLbl: 'Amount Due',
    checkNumberLbl: 'Check Number',
    marketSegmentLbl: 'Market Segment',
    paymentStatusLbl: 'Payment Status',
    invoiceStatusLbl: 'Invoice Status',
    exportToExcelLbl: 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    customerNumberLbl: 'Customer Number',
    customerNameLbl: 'Customer Name',
    downloadInvoiceLbl:'Download Invoice'
  };
  protected invlblText: IInvoiceInquiryLbl = {
    invoiceInquiryLbl: '',
    invoiceNumberLbl: '',
    invoiceDateLbl: '',
    invoiceTypeLbl: '',
    poLbl: '',
    jobNameLbl: '',
    originalAmountLbl: '',
    amountDueLbl: '',
    checkNumberLbl: '',
    marketSegmentLbl: '',
    invoiceStatusLbl: '',
    exportToExcelLbl: '',
    exportToPDFLbl: '',
    customerNumberLbl: '',
    customerNameLbl: '',
    paymentStatusLbl: '',
    downloadInvoiceLbl:''
  };
  //#endregion


  //#region Grid data binding
  private loadInvoiceInquiryGrid(fromDate: Date, toDate: Date): void {
    this.invoiceLoading = true;
    const body: IGetOrdersInquiryBody = {
      customerNumber: '',
      fromDate: fromDate,
      toDate: toDate
    }    
    this.orderService.getInvoiceInquiry(body).subscribe((response: Array<any>) => {
      this.invoiceLoading = false;
      if (response) {
        this.invoiceGridData = response;
        this.orderService.setInvoiceInquiryGridData(this.invoiceGridData);
        this.initPaymentOptions();
        this.loadInvoiceGridData();
      }
    }, err => {
      this.initPaymentOptions();
      this.appNotifyService.notify(NotifyType.ERROR, 'Soory an error occured while loading the page.');
    })
  }
  //#endregion

  //#region pagination, sorting,filtering for invoice grid
  todaysDated: Date = new Date()
  toDate: Date = new Date();
  fromDate: Date = new Date(this.toDate.getFullYear() - 1, this.toDate.getMonth(), this.toDate.getDay());
  public invoiceGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'invoiceNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: [{
        field: "invoiceDateAsDate", operator: "gte", value: this.fromDate
      }, {
        field: "invoiceDateAsDate", operator: "lte", value: this.toDate
      }]
    },
  };

  //#region All column settings for the Grid
  public invoiceGridSettings: GridSettings = {
    state: this.invoiceGridstate,
    gridData: process(this.invoiceGridData, this.invoiceGridstate),
    columnsConfig: [{
      field: 'invoiceNumber',
      title: this.invlblText.invoiceNumberLbl ? this.invlblText.invoiceNumberLbl : this.invoiceInquiry.invoiceNumberLbl,
      filterable: true,
      widthForPDF: 40
      //_width: 220,
    },
    {
      field: 'invoiceDateAsDate',
      title: this.invlblText.invoiceDateLbl ? this.invlblText.invoiceDateLbl : this.invoiceInquiry.invoiceDateLbl,
      filterable: true,
      format: '{0:d}',
      _width: 220,
      widthForPDF: 45
    }, {
      field: 'type',
      title: this.invlblText.invoiceTypeLbl ? this.invlblText.invoiceTypeLbl : this.invoiceInquiry.invoiceTypeLbl,
      filterable: true,
      widthForPDF: 25
    }, {
      field: 'poNumber',
      title: this.invlblText.poLbl ? this.invlblText.poLbl : this.invoiceInquiry.poLbl,
      filterable: true,
      widthForPDF: 45
    }, {
      field: 'jobName',
      title: this.invlblText.jobNameLbl ? this.invlblText.jobNameLbl : this.invoiceInquiry.jobNameLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 70
    }
      , {
      field: 'originalAmount',
      title: this.invlblText.originalAmountLbl ? this.invlblText.originalAmountLbl : this.invoiceInquiry.originalAmountLbl,
      filterable: true,
      widthForPDF: 40
    }
      ,
    {
      field: 'amountDue',
      title: this.invlblText.amountDueLbl ? this.invlblText.amountDueLbl : this.invoiceInquiry.amountDueLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 40
    }, {
      field: 'checkNumber',
      title: 'Check/Confirmation Number',//;this.invlblText.checkNumberLbl ? this.invlblText.checkNumberLbl : this.invoiceInquiry.checkNumberLbl,
      filterable: true,
      widthForPDF: 55
    }, {
      field: 'marketSegment',
      title: this.invlblText.marketSegmentLbl ? this.invlblText.marketSegmentLbl : this.invoiceInquiry.marketSegmentLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 60
    }, {
      field: 'paymentStatus', 
      title: this.invlblText.paymentStatusLbl ? this.invlblText.paymentStatusLbl : this.invoiceInquiry.paymentStatusLbl,
      filterable: true,
      widthForPDF: 30
    }, {
        field: 'downloadPdf',
        title: this.invlblText.downloadInvoiceLbl ? this.invlblText.downloadInvoiceLbl : this.invoiceInquiry.downloadInvoiceLbl,
        filterable: false,
        widthForPDF: 0
      }
    ]
  };
  public onReorder(e: any): void {
    const reorderedColumn = this.invoiceGridSettings.columnsConfig.splice(e.oldIndex, 1);
    this.invoiceGridSettings.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
    this.saveGrid();
  }
  public onVisibilityChange(e: any): void {
    e.columns.forEach(column => {
      this.invoiceGridSettings.columnsConfig.find(col => col.field === column.field).hidden = column.hidden;
    });

    this.saveGrid();
  }
  public onResize(e: any): void {
    e.forEach(item => {
      this.invoiceGridSettings.columnsConfig.find(col => col.field === item.column.field).width = item.newWidth;
    });

    this.saveGrid();
  }
  private saveGrid(): void {
    this.invoiceGridSettings.state.skip = 0;
    const gridConfig = {
      columnsConfig: this.invoiceGridSettings.columnsConfig,
      state: this.invoiceGridSettings.state
    };

    this.persistingService.set(this.orderService.readUserObject.userName + 'invoiceInquiryGridSetting', gridConfig);
  }

  public mapGridSettings(gridSettings: GridSettings): GridSettings {
    const state = gridSettings.state;
    let a = [];
    //may need some additional sanity checks here
    let minDate = state.filter.filters.find(x => x['field'] === 'invoiceDateAsDate' && x['operator'] === 'gte');
    let maxDate = state.filter.filters.find(x => x['field'] === 'invoiceDateAsDate' && x['operator'] === 'lte');

    if (!minDate || !maxDate) {
      minDate = this.invoiceGridstate.filter.filters.find(x => x['field'] === 'invoiceDateAsDate' && x['operator'] === 'gte');
      maxDate = this.invoiceGridstate.filter.filters.find(x => x['field'] === 'invoiceDateAsDate' && x['operator'] === 'lte');
    }

    //just test code

    var paymentStatFilter = this.invoiceGridstate.filter.filters.find(x => x['field'] === 'paymentStatus' && x['operator'] === 'eq' && x['value'] === 'OPEN');// field: "paymentStatus", operator: "eq", value: "OPEN"

    a.push(minDate);
    a.push(maxDate);
    if (paymentStatFilter) {
      a.push(paymentStatFilter);
    }
    gridSettings.state.filter.filters = a;

    const filters: any[] = state.filter.filters || [];
    filters.forEach(filter => {
      if (filter.field === 'invoiceDateAsDate' && filter.value) {
        filter.value = new Date(filter.value);
      }
      else {
        const index: number = filters.indexOf(filter);
        if (index !== -1) {
          filters.splice(index, 1);
        }
      }

    });
    var invoiceDatefilter = filters.filter(f => f.field == "invoiceDateAsDate")
    if (invoiceDatefilter && invoiceDatefilter.length > 0) {
      var tempFromFilter = invoiceDatefilter.find(f => f.operator == "gte");
      if (tempFromFilter) {
        this.fromDate = new Date(tempFromFilter.value);
      }
      var tempToFilter = invoiceDatefilter.find(f => f.operator == "lte");
      if (tempToFilter) {
        this.toDate = new Date(tempToFilter.value);
      }
      //invoiceDatefilter.forEach(filter => {
      //  this.fromDate = (filter.operator == "gte") ? new Date(filter.value) : this.fromDate;
      //  this.toDate = (filter.operator == "lte") ? new Date(filter.value) : new Date("12/31/2099");
      //});
    }
    else {
      state.filter = this.invoiceGridstate.filter;
    }
    //---------------------------
    state.skip = 0;
    return {
      state,
      columnsConfig: gridSettings.columnsConfig.sort((a, b) => a.orderIndex - b.orderIndex),
      gridData: process(this.invoiceGridData, state)
    };
  }
  //private mapDateFilter = (descriptor: any) => {
  //  const filters: any[] = descriptor.filters || [];
  //  debugger;

  //}
  //#endregion
  //#endregion


  private loadInvoiceGridData(): void {
    if (this.invoiceGridSettings.state)
      this.invoiceInquiryGridData = process(this.invoiceGridData, this.invoiceGridSettings.state);
    else
      this.invoiceInquiryGridData = process(this.invoiceGridData, this.invoiceGridstate);
    this.invoiceGridSettings.gridData = this.invoiceInquiryGridData;
    console.log(this.invoiceInquiryGridData);
  }

  protected invoiceGridSortChange(sort): void {
    this.invoiceGridstate.sort = sort;
    this.loadInvoiceGridData();
  }

  protected invoiceGridPageChange({ skip, take }: PageChangeEvent): void {
    this.invoiceGridstate.skip = skip;
    this.invoiceGridstate.take;
    this.loadInvoiceGridData();
  }
  //when older date from fromDate and later date from toDate is selected
  //api call would be made or else filter would happen clientside
  public invoiceDataStateChange(state: DataStateChangeEvent): void {
    this.invoiceGridstate = state;
    this.invoiceGridSettings.state = this.invoiceGridstate;
    var newFromDate = new Date("01/01/2000");
    var newToDate = new Date("12/31/2099");
    const filters: any[] = state.filter.filters || [];
    var invoiceDatefilter = filters.filter(f => f.field == "invoiceDateAsDate")
    if (invoiceDatefilter) {
      this.searchText = '';
      var tempFromFilter = invoiceDatefilter.find(f => f.operator == "gte");
      if (tempFromFilter) {
        newFromDate = new Date(tempFromFilter.value);
      }
      var tempToFilter = invoiceDatefilter.find(f => f.operator == "lte");
      if (tempToFilter) {
        newToDate = new Date(tempToFilter.value);
      }
      //invoiceDatefilter.forEach(filter => {
      //  newFromDate = (filter.operator == "gte") ? new Date(filter.value) : newFromDate;
      //  newToDate = (filter.operator == "lte") ? new Date(filter.value) : newToDate;
      //});
      if ((newFromDate && newFromDate < this.fromDate) || (newToDate && newToDate > this.toDate)) {
        this.fromDate = newFromDate;
        this.toDate = newToDate;
        this.loadInvoiceInquiryGrid(newFromDate, newToDate);
      }
      else {
        this.loadInvoiceGridData();
      }
    }
    else {
      this.loadInvoiceGridData();
    }
    this.saveGrid();
  }

  //#endregion
  //public get start(): Date {
  //  const state = this.invoiceGridSettings.state;
  //  const filters: any[] = state.filter.filters || [];
  //  var invoiceDatefilter = filters.filter(f => f.field == "invoiceDateAsDate")
  //  if (invoiceDatefilter) {
  //    var tempFromFilter = invoiceDatefilter.find(f => f.operator == "gte");
  //    if (tempFromFilter) {
  //      return new Date(tempFromFilter.value);
  //    }
  //  }
  //  return this.fromDate;
  //}
  //public get end(): Date {
  //  const state = this.invoiceGridSettings.state;
  //  const filters: any[] = state.filter.filters || [];
  //  var invoiceDatefilter = filters.filter(f => f.field == "invoiceDateAsDate")
  //  if (invoiceDatefilter) {
  //    var tempFromFilter = invoiceDatefilter.find(f => f.operator == "lte");
  //    if (tempFromFilter) {
  //      return new Date(tempFromFilter.value);
  //    }
  //  }
  //  return this.toDate;
  //}
  //public filterRange(start: Date, end: Date): void {
  //  console.log(start);
  //  console.log(end);
  //  const filters: any[] = this.invoiceGridSettings.state.filter.filters || [];
  //  console.log(filters);
  //}
  //row click event
  invoiceInquiryData(val: string) {
    const rowData = this.invoiceInquiryGridData.data.find(r => r.invoiceNumber == val);
    this.orderService.setInvoiceInquiryData(rowData);
  }

  public data: any[] = process(sampleProducts, {

  }).data;

  async generatePDF() {
    //debugger;
    this.loadingPDF = true;
    var currFilter = this.invoiceGridSettings.state.filter;
    var filterData = process(this.invoiceGridData, {
      filter: currFilter
    });
    //#region - format data based on column settings
    var titleOutput = [];
    var fieldOutput = [];
    var widthOutput = [];
    this.invoiceGridSettings.columnsConfig.filter(c => c.hidden != true && c.widthForPDF > 0).forEach(c => {
      titleOutput.push(c.title);
      if (c.title === this.invoiceInquiry.invoiceDateLbl)
        fieldOutput.push("invoiceDateUIString");//temp fix. Need to remove.
      else
        fieldOutput.push(c.field);
      widthOutput.push(c.widthForPDF);
    });
    //debugger;
    var dataArray: any[] = [];
    filterData.data.forEach(d => {
      dataArray.push(_.pick(d, fieldOutput));
    });
    //#endregion
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: this.invlblText.invoiceInquiryLbl ? this.invlblText.invoiceInquiryLbl : this.invoiceInquiry.invoiceInquiryLbl, alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          text: this.invlblText.customerNumberLbl ? this.invlblText.customerNumberLbl : this.invoiceInquiry.customerNumberLbl + ": " + this.orderService.readUserObject.customerNumber,
          bold: true,
          margin: [0, 15, 0, 15]
        },
        {
          text: this.invlblText.customerNameLbl ? this.invlblText.customerNameLbl : this.invoiceInquiry.customerNameLbl + ": " + this.orderService.readUserObject.customerName,
          bold: true,
          margin: [0, 15, 0, 15]
        },
        {
          text: "Invoice Inquiry List",
          style: 'sectionHeader'
        },
        {
          style: 'tableStyle',
          table: {
            headerRows: 1,
            //widths: ['*'],
            widths: widthOutput,
            body: [
              //[
              //this.invlblText.invoiceNumberLbl ? this.invlblText.invoiceNumberLbl : this.invoiceInquiry.invoiceNumberLbl,
              //this.invlblText.invoiceDateLbl ? this.invlblText.invoiceDateLbl : this.invoiceInquiry.invoiceDateLbl,
              //this.invlblText.invoiceTypeLbl ? this.invlblText.invoiceTypeLbl : this.invoiceInquiry.invoiceTypeLbl,
              //this.invlblText.poLbl ? this.invlblText.poLbl : this.invoiceInquiry.poLbl,
              //this.invlblText.jobNameLbl ? this.invlblText.jobNameLbl : this.invoiceInquiry.jobNameLbl,
              //this.invlblText.originalAmountLbl ? this.invlblText.originalAmountLbl : this.invoiceInquiry.originalAmountLbl,
              //this.invlblText.amountDueLbl ? this.invlblText.amountDueLbl : this.invoiceInquiry.amountDueLbl,
              //this.invlblText.checkNumberLbl ? this.invlblText.checkNumberLbl : this.invoiceInquiry.checkNumberLbl,
              //this.invlblText.marketSegmentLbl ? this.invlblText.marketSegmentLbl : this.invoiceInquiry.marketSegmentLbl,
              // this.invlblText.invoiceStatusLbl ? this.invlblText.invoiceStatusLbl : this.invoiceInquiry.invoiceStatusLbl],
              titleOutput,
              //...this.invoiceGridData.map(p =>
              //  ([
              //    p.invoiceNumber,
              //    p.invoiceDateUIString ? p.invoiceDateUIString : '',
              //    p.type ? p.type : '',
              //    p.po ? p.po : '',
              //    p.jobName ? p.jobName : '',
              //    p.originalAmount ? p.originalAmount : '',
              //    p.amountDue ? p.amountDue : '',
              //    p.checkNumber ? p.checkNumber : '',
              //    p.marketSegment ? p.marketSegment : '',
              //    p.invoiceStatus ? p.invoiceStatus : '',
              //  ])
              //)
              ...dataArray.map(p =>
                ([
                  ...Object.values(p).map(v => { v = v ? v : ""; return v; })
                ])
              )
            ]
          }
        }
      ],
      footer: {
        columns: [
          { text: '©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        headerLeft: {
          fontSize: 22,
        },
        headerRight: {
          fontSize: 22,
          alignment: 'center'
        },
        anotherStyle: {
          italics: true,
          alignment: 'right'
        },
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        tableStyle: {
          fontSize: 8
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('InvoiceInquiry.pdf');
    this.loadingPDF = false;
  }


  generateExcel() {
    this.loadingExcel = true;
    var currFilter = this.invoiceGridSettings.state.filter;
    var filterData = process(this.invoiceGridData, {
      filter: currFilter
    });
    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    //#region - format data based on column settings
    var titleOutput = [];
    var fieldOutput = [];
    this.invoiceGridSettings.columnsConfig.filter(c => c.hidden != true).forEach(c => {
      titleOutput.push(c.title);
      fieldOutput.push(c.field);
    });
    //debugger;
    var dataArray: any[] = [];
    filterData.data.forEach(d => {
      dataArray.push(_.pick(d, fieldOutput));
    });
    //#endregion
    let worksheet = workbook.addWorksheet(this.invlblText.invoiceInquiryLbl ? this.invlblText.invoiceInquiryLbl : this.invoiceInquiry.invoiceInquiryLbl);
    const header = titleOutput;
    //  [
    //this.invlblText.invoiceNumberLbl ? this.invlblText.invoiceNumberLbl : this.invoiceInquiry.invoiceNumberLbl,
    //this.invlblText.invoiceDateLbl ? this.invlblText.invoiceDateLbl : this.invoiceInquiry.invoiceDateLbl,
    //this.invlblText.invoiceTypeLbl ? this.invlblText.invoiceTypeLbl : this.invoiceInquiry.invoiceTypeLbl,
    //this.invlblText.poLbl ? this.invlblText.poLbl : this.invoiceInquiry.poLbl,
    //this.invlblText.jobNameLbl ? this.invlblText.jobNameLbl : this.invoiceInquiry.jobNameLbl,
    //this.invlblText.originalAmountLbl ? this.invlblText.originalAmountLbl : this.invoiceInquiry.originalAmountLbl,
    //this.invlblText.amountDueLbl ? this.invlblText.amountDueLbl : this.invoiceInquiry.amountDueLbl,
    //this.invlblText.checkNumberLbl ? this.invlblText.checkNumberLbl : this.invoiceInquiry.checkNumberLbl,
    //this.invlblText.marketSegmentLbl ? this.invlblText.marketSegmentLbl : this.invoiceInquiry.marketSegmentLbl,
    // this.invlblText.invoiceStatusLbl ? this.invlblText.invoiceStatusLbl : this.invoiceInquiry.invoiceStatusLbl];
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let ClientIdRow = worksheet.addRow([this.invlblText.customerNumberLbl ? this.invlblText.customerNumberLbl : this.invoiceInquiry.customerNumberLbl + ":" + this.orderService.readUserObject.customerNumber + '']);
    ClientIdRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    let ClientNameRow = worksheet.addRow([this.invlblText.customerNameLbl ? this.invlblText.customerNameLbl : this.invoiceInquiry.customerNameLbl + ":" + this.orderService.readUserObject.customerName + '']);
    ClientNameRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    worksheet.addRow([]);

    let invoiceDetailsRow = worksheet.addRow([this.invlblText.invoiceInquiryLbl ? this.invlblText.invoiceInquiryLbl : this.invoiceInquiry.invoiceInquiryLbl]);
    invoiceDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    //this.invoiceGridData.map(p =>
    //  ([
    //    p.invoiceNumber,
    //    p.invoiceDateUIString ? p.invoiceDateUIString : '',
    //    p.type ? p.type : '',
    //    p.po ? p.po : '',
    //    p.jobName ? p.jobName : '',
    //    p.originalAmount ? p.originalAmount : '',
    //    p.amountDue ? p.amountDue : '',
    //    p.checkNumber ? p.checkNumber : '',
    //    p.marketSegment ? p.marketSegment : '',
    //    p.invoiceStatus ? p.invoiceStatus : '',
    //  ])
    //)
    dataArray.map(p =>
      ([
        ...Object.values(p).map(v => { v = v ? v : ""; return v; })
      ])
    )
      .forEach(d => {
        let row = worksheet.addRow(d);
      });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'InvoiceInquiry.xlsx');
    })
    this.loadingExcel = false;
  }

  public onFilterInvoiceInquiry(inputValue: string): void {
    var primaryFilter = this.invoiceGridSettings.state.filter;
    var primaryFilteredData = process(this.invoiceGridData, {
      filter: primaryFilter
    });
    this.invoiceInquiryGridData = process(primaryFilteredData.data, {
      filter: {
        logic: "or",
        filters: [
          {
            field: "invoiceNumber",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "invoiceDateUIString",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "type",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "po",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "jobName",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "originalAmount",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "amountDue",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "checkNumber",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "marketSegment",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "PaymentStatus",
            operator: "contains",
            value: inputValue,
          },
        ],
      },
    });
    if (!inputValue) {
      this.invoiceGridstate.skip = 0;
      this.invoiceGridstate.take = 10;
      this.loadInvoiceGridData();
    }
    //this.dataBinding.skip = 0;
  }

  initializeGridHeader() {

    this.invoiceGridSettings.columnsConfig.forEach((el) => {
      if (el.field == 'invoiceNumber') {
        el.title = this.invlblText.invoiceNumberLbl ? this.invlblText.invoiceNumberLbl : this.invoiceInquiry.invoiceNumberLbl;
      }

      if (el.field == 'invoiceDateAsDate') {
        el.title = this.invlblText.invoiceDateLbl ? this.invlblText.invoiceDateLbl : this.invoiceInquiry.invoiceDateLbl;
      }
      if (el.field == 'type') {
        title: this.invlblText.invoiceTypeLbl ? this.invlblText.invoiceTypeLbl : this.invoiceInquiry.invoiceTypeLbl;
      }
      if (el.field == 'poNumber') {
        el.title = this.invlblText.poLbl ? this.invlblText.poLbl : this.invoiceInquiry.poLbl;
      }
      if (el.field == 'jobName') {
        el.title = this.invlblText.jobNameLbl ? this.invlblText.jobNameLbl : this.invoiceInquiry.jobNameLbl;
      }
      if (el.field == 'originalAmount') {
        el.title = this.invlblText.originalAmountLbl ? this.invlblText.originalAmountLbl : this.invoiceInquiry.originalAmountLbl;
      }
      if (el.field == 'amountDue') {
        el.title = this.invlblText.amountDueLbl ? this.invlblText.amountDueLbl : this.invoiceInquiry.amountDueLbl;
      }
      if (el.field == 'checkNumber') {
        el.title = 'Check/Confirmation Number';///this.invlblText.checkNumberLbl ? this.invlblText.checkNumberLbl : this.invoiceInquiry.checkNumberLbl;
      }
      if (el.field == 'marketSegment') {
        el.title = this.invlblText.marketSegmentLbl ? this.invlblText.marketSegmentLbl : this.invoiceInquiry.marketSegmentLbl;
      }
      if (el.field == 'paymentStatus') {
        el.title = this.invlblText.paymentStatusLbl ? this.invlblText.paymentStatusLbl : this.invoiceInquiry.paymentStatusLbl;
      }
      if (el.field == 'downloadInvoice') {
        el.title = 'Download Invoice';
      }
    });
  }


  //#region Payment test
  showPaymentOptions: boolean = false;
  paymentStatusList =
    [
      //{ name: 'All', value: 'All' },
      { name: 'Paid', paymentStatus: 'PAID' },
      { name: 'Open', paymentStatus: 'OPEN' },
      { name: 'Payment In Progress', paymentStatus: 'Payment In Progress' }];
  previousUrl: string;
  initPaymentOptions() {
    this.showPaymentOptions = this.userService.hasAccessToMakeInvoicePayment();     
  }
  proceedToPaymentScreen() {   
    this.router.navigate(['/invoice-inquiry/payment/review']);
  }

  testPreserveHistory() {

  }
  //#endregion

  pdfBody: IGetInvoicePdfBody = {
    invoiceNumber: 0,
    invoiceType: '',
    customerNumber:''
  }

  downloadInvoice(pdfItem) {
    pdfItem.downloadProgress = true;
    this.pdfBody.invoiceNumber = pdfItem.invoiceNumber;
    this.pdfBody.invoiceType = pdfItem.type;
    this.pdfBody.customerNumber = pdfItem.billTo;
    this.orderService.downloadInvoice(this.pdfBody).subscribe((response) => {
      if (response) {
        //Code to open pdf in new tab------------End
        //Code to download pdf automatically----------- Start
        //console.log(response.urlPath);
        if (response.urlPath == null) {
          this.appNotifyService.notify(NotifyType.ERROR, 'Sorry an error occured while downloading the Invoice PDF.');
        } else {
          const linkSource = 'data:application/pdf;base64,' + response.urlPath;
          const downloadLink = document.createElement("a");
          let ms = Date.now();
          const fileName = response.fileName;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();          
        }        
        //Code to download pdf automatically----------- End
      }
      pdfItem.downloadProgress = false;      
    }, err => {
      this.appNotifyService.notify(NotifyType.ERROR, 'Sorry an error occured while downloading the Invoice PDF.');
    });
  }
}
